import * as Oidc from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Settings } from '../Settings';

export class LogoutComponent extends React.Component<any, any> {
  componentWillMount() {
    const manager = new Oidc.UserManager(Settings);

    if (this.props.location.search.indexOf('?success') >= 0) {
      manager.signoutRedirectCallback().then((u) => this.props.logout(u));
    } else {
      manager.signoutRedirect();
    }
  }
  render() {
    return (
      <div>
        <h3>Log out</h3>
        <p>You have logged out.</p>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogoutComponent));

function mapStateToProps(store: any) {
  return {
  };
}

function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    logout(user: any) {
      dispatch({ type: 'USER_LOGIN', loggedInUser: null, userPermissions: null });
    },
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/authentication/components/Logout.tsx